<script lang="ts">
	export let result_link: string = '';
</script>

<div class="flex flex-col items-center justify-center gap-[29.014px]">
	<svg xmlns="http://www.w3.org/2000/svg" width="72" height="73" viewBox="0 0 72 73" fill="none">
		<path
			d="M28.6755 38.703L33.7903 45.0591L42.4308 30.4101M26.5099 17.9197L20.6888 16.9147C17.4424 16.3543 14.6197 19.177 15.1801 22.4234L16.1851 28.2445C16.2895 28.849 16.0366 29.4596 15.5354 29.8132L10.7086 33.2187C8.01672 35.1179 8.01672 39.1099 10.7086 41.0091L15.5354 44.4146C16.0366 44.7683 16.2895 45.3789 16.1851 45.9834L15.1801 51.8045C14.6197 55.0508 17.4424 57.8736 20.6888 57.3131L26.5099 56.3081C27.1144 56.2037 27.725 56.4567 28.0786 56.9579L31.4841 61.7847C33.3833 64.4765 37.3753 64.4765 39.2745 61.7847L42.68 56.9579C43.0337 56.4567 43.6443 56.2037 44.2488 56.3081L50.0699 57.3131C53.3163 57.8736 56.139 55.0508 55.5785 51.8045L54.5735 45.9834C54.4692 45.3789 54.7221 44.7683 55.2233 44.4146L60.0501 41.0091C62.7419 39.1099 62.7419 35.1179 60.0501 33.2187L56.8646 30.9713C55.3609 29.9103 54.6022 28.0785 54.9153 26.265L55.5785 22.4234C56.139 19.177 53.3163 16.3543 50.0699 16.9147L44.2488 17.9197C43.6443 18.0241 43.0337 17.7712 42.68 17.2699L39.2745 12.4431C37.3753 9.75131 33.3833 9.75131 31.4841 12.4431L28.0786 17.2699C27.725 17.7712 27.1144 18.0241 26.5099 17.9197Z"
			stroke="#9A77FF"
			stroke-width="4.96552"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>

	<div class="text-center font-sora text-[48px] font-bold not-italic leading-[46px] text-[#018171]">
		Pronto!<br /> A sua simulação<br /> está concluída.
	</div>
	<div class="text-center">
		Se o resultado não abriu<br /> automaticamente, é só
		<a
			href={result_link}
			class="font-sora text-[16px] font-semibold not-italic leading-normal text-[#018171]"
			target="_blank">clicar aqui.</a
		>
	</div>
</div>
